export const DASHBOARD = '/main'
export const SIGNUP = '/signup'
export const LOGIN = '/login'
